export default __webpack_public_path__ + "assets/pdf/user_guide_af_klm_v3.b6815040.pdf";